import logo from '@/images/logo-blanco.png';

const footerLinks = {
  soluciones: {
    title: 'Soluciones',
    links: [
      { label: 'Crédito Personal', href: '/credito-personal' },
      { label: 'Crédito PyME', href: '/credito-pyme' },
      { label: 'Distribuidores', href: '/conviertete-en-distribuidor' },
    ],
  },
  empresa: {
    title: 'Empresa',
    links: [
      { label: 'Aviso de Privacidad', href: '/aviso-de-privacidad.pdf', download: true },
      { label: 'CONDUSEF', href: 'https://www.condusef.gob.mx', isExternal: true },
    ],
  },
  contacto: {
    title: 'Contacto',
    links: [
      { label: 'Solicitar Crédito', href: '#contacto' },
      { label: 'Preguntas Frecuentes', href: '#faq' },
    ],
  },
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="relative"
      style={{
        background: 'linear-gradient(180deg, oklch(var(--primary-800)) 0%, oklch(var(--primary-900)) 100%)',
      }}
    >
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent 0%, oklch(var(--accent-500) / 0.4) 25%, oklch(var(--accent-500) / 0.6) 50%, oklch(var(--accent-500) / 0.4) 75%, transparent 100%)' }}></div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="/" className="flex items-center gap-3 mb-5 group">
              <img
                src={logo}
                alt="Crece Prestaciones"
                className="h-12 w-auto transition-all duration-300 group-hover:scale-105"
              />
            </a>
            <p className="text-white/35 text-sm leading-relaxed mb-6 max-w-xs">
              Sociedad Financiera de Objeto Múltiple. Impulsando el crecimiento financiero de personas y empresas en México desde hace más de 6 años.
            </p>
            <div className="flex items-center gap-2.5">
              {[
                { icon: 'ri-facebook-line', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-tiktok-line', href: '#' },
                { icon: 'ri-whatsapp-line', href: '#' },
                { icon: 'ri-mail-line', href: 'mailto:atencionaclientes@creceprestaciones.com' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  className="w-9 h-9 rounded-xl flex items-center justify-center bg-white/5 hover:bg-accent-500 transition-all duration-300 text-white/40 hover:text-white cursor-pointer group/social"
                >
                  <i className={`${social.icon} text-sm transition-transform duration-300 group-hover/social:scale-110`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-white text-sm font-semibold mb-5 tracking-wide" style={{ fontFamily: 'var(--font-heading)' }}>
                {section.title}
              </h4>
              <ul className="space-y-3.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a                      
                      href={link.href}
                      onClick={(e) => {
                        if (link.href.startsWith('#')) {
                          e.preventDefault();
                          document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                      {...(link.isExternal ? { target: '_blank', rel: 'nofollow noopener' } : {})}
                      {...(link.download ? { download: true } : {})}
                      className="text-white/35 text-sm hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap inline-flex items-center gap-1.5 group"
                    >
                      {link.label}
                      {link.isExternal && <i className="ri-external-link-line text-xs opacity-50 group-hover:opacity-100 transition-opacity"></i>}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div style={{ borderTop: '1px solid oklch(var(--primary-600) / 0.3)' }}>
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/20 text-xs">
            &copy; {currentYear} Crece Prestaciones. Todos los derechos reservados.
          </p>
          <p className="text-white/15 text-xs flex items-center gap-2 flex-wrap justify-center">
            <span className="flex items-center gap-1">
              <i className="ri-government-line text-[10px]"></i>
              Registrado ante CONDUSEF
            </span>
            <span className="text-white/10">•</span>
            <span>SOFOM E.N.R.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}